import type { GetIncidentActionResponse } from '../hooks/incidentActionHooks';

/** Stable id for map graphics / hide toggles. */
export function getActionMapId(
  action: Pick<GetIncidentActionResponse, 'action_id' | 'id'>
): string {
  return String(action.action_id || action.id);
}
